import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Card from '../card/card';
import Slug from '../slug/slug';

export default function RelatedPosts(props) {
  if (!props) {
    return null;
  }

  const { stories, fullPageAdvertorial } = props;
  const topic =
    get(stories, '[0].categories[0].slug') ||
    get(stories, '[1].categories[0].slug') ||
    '';

  if (stories && stories.length < 2) return null;

  return (
    <div className="related-posts">
      <Slug
        slugName="Related Stories"
        className="column"
        linkTo={`/${topic}`}
      />
      {stories.map(item =>
        <Card
          className="related-posts"
          metadata={item}
          key={item.id}
          fullPageAdvertorial={fullPageAdvertorial}
        />
      )}
    </div>
  );
}

RelatedPosts.defaultProps = {
  fullPageAdvertorial: false
};

RelatedPosts.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fullPageAdvertorial: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/views/components/related_posts/related_posts.js